import { Component } from 'react'
import ReactDOM from 'react-dom'

const modalRoot = document.getElementById('DevTools')

export class DevToolsPortal extends Component {
	private el: any
	constructor(props: any) {
		super(props)
		this.el = document.createElement('div')
	}

	public override componentDidMount() {
		modalRoot?.appendChild(this.el)
	}

	public override componentWillUnmount() {
		modalRoot?.removeChild(this.el)
	}

	public override render() {
		return ReactDOM.createPortal(this.props.children, this.el)
	}
}
